
import { Vue, Component, Prop, Emit } from "vue-property-decorator"
import api from "../honcierge-api"
import Base64Uploader from "@/components/Base64Uploader.vue"
import DeleteButtonWithConfirm from "@/components/DeleteButtonWithConfirm.vue"
import { AdminUser } from "types/adminUser"
import { AxiosError } from "axios"

@Component({
  components: { Base64Uploader, DeleteButtonWithConfirm },
})
export default class EditAdminUser extends Vue {
  get title(): string {
    return this.id === 0 || this.id ? "編集" : "新規作成"
  }
  @Prop()
  public role!: string

  @Prop({ default: null })
  private id!: number | null
  @Prop({ default: 1 })
  private page!: number

  private thumbnailUploaderLabel = "サムネイル"
  private email = ""
  private name = ""
  private position = ""
  private description = ""
  private password = ""
  private thumbnail: { content: string; filename: string } = {
    content: "",
    filename: "",
  }
  private twitterUrl: AdminUser["data"]["twitterUrl"] = null
  private instagramUrl: AdminUser["data"]["instagramUrl"] = null
  private youtubeUrl: AdminUser["data"]["youtubeUrl"] = null
  private linkUrl: AdminUser["data"]["linkUrl"] = null
  private dialog = false

  // rules for form
  private emailRules = [(email: string) => !!email || "Eメールは必須です"]
  private nameRules = [(name: string) => !!name || "ユーザ名は必須です"]

  public createOrUpdateAdminUser(): void {
    if (!this.validate()) {
      return
    }
    if (this.id !== null) {
      api
        .updateAdminUser(
          this.id,
          this.email,
          this.name,
          this.position,
          this.description,
          this.password,
          this.thumbnail.content,
          this.thumbnail.filename,
          this.twitterUrl || null,
          this.instagramUrl || null,
          this.youtubeUrl || null,
          this.linkUrl || null
        )
        .then((res) => {
          this.email = res.data.adminUser.email
          this.name = res.data.adminUser.name
          this.position = res.data.adminUser.position
          this.description = res.data.adminUser.description
          this.twitterUrl = res.data.adminUser.twitterUrl
          this.instagramUrl = res.data.adminUser.instagramUrl
          this.youtubeUrl = res.data.adminUser.youtubeUrl
          this.linkUrl = res.data.adminUser.linkUrl
          this.emitUpdateAdminUser(res.data.adminUser, this.page)
        })
        .catch((e: AxiosError) => {
          if (e.response) {
            e.response.data.messages.forEach((messsage: string) => {
              this.$toasted.error(messsage)
            })
          }
        })
    } else {
      api
        .createAdminUser(
          this.email,
          this.name,
          this.password,
          this.position,
          this.description,
          this.role,
          this.thumbnail.content,
          this.thumbnail.filename,
          this.twitterUrl || null,
          this.instagramUrl || null,
          this.youtubeUrl || null,
          this.linkUrl || null
        )
        .then(() => {
          this.emitCreateAdminUser()
        })
        .catch((e: AxiosError) => {
          if (e.response) {
            e.response.data.messages.forEach((message: string) => {
              this.$toasted.error(message)
            })
          }
        })
    }
  }

  public deleteAdminUser(): void {
    if (this.id != null) {
      api
        .deleteAdminUser(this.id)
        .then(() => {
          this.emitDeleteAdminUser(this.page)
        })
        .catch((error: AxiosError) => {
          console.log(error.stack)
          this.$toasted.error("アカウントの削除に失敗しました")
        })
    }
  }

  private init() {
    this.email = ""
    this.name = ""
    this.position = ""
    this.description = ""
    this.password = ""
    this.thumbnail = { content: "", filename: "" }
    const base64Uploader = this.$refs.base64Uploader as InstanceType<
      typeof Base64Uploader
    >
    base64Uploader.filename = ""
    this.twitterUrl = null
    this.instagramUrl = null
    this.youtubeUrl = null
    this.linkUrl = null
  }

  private clear() {
    this.init()
    this.resetValidation()
  }

  private close() {
    this.dialog = false
    this.clear()
  }

  @Emit("emitCreateAdminUser")
  private emitCreateAdminUser() {
    this.close()
  }
  @Emit("emitUpdateAdminUser")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private emitUpdateAdminUser(adminUser: AdminUser["data"], page: number) {
    this.close()
  }
  @Emit("emitDeleteAdminUser")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private emitDeleteAdminUser(page: number) {
    this.close()
  }

  private validate(): boolean {
    const form = this.$refs.form as InstanceType<typeof EditAdminUser>
    return form.validate()
  }

  private resetValidation(): void {
    const form = this.$refs.form as InstanceType<typeof EditAdminUser>
    return form.resetValidation()
  }

  private loadImage(image: string, filename: string) {
    this.thumbnail.content = image
    this.thumbnail.filename = filename
  }

  public async open() {
    try {
      if (this.id != null) {
        const response = await api.getAdminUserById(this.id)
        const adminUser = response.data.adminUser
        this.name = adminUser.name
        this.email = adminUser.email
        this.position = adminUser.position
        this.description = adminUser.description
        this.twitterUrl = adminUser.twitterUrl
        this.instagramUrl = adminUser.instagramUrl
        this.youtubeUrl = adminUser.youtubeUrl
        this.linkUrl = adminUser.linkUrl
      }
      this.dialog = true
    } catch {
      this.$toasted.error("アカウントの取得に失敗しました")
    }
  }
}
